"use strict";

exports.__esModule = true;
exports.spaceParser = exports.space = void 0;

var _core = require("../core");

var _utils = require("../utils");

var config = {
  margin: _utils.t.spaceT("margin"),
  marginTop: _utils.t.spaceT("marginTop"),
  marginBlockStart: _utils.t.spaceT("marginBlockStart"),
  marginRight: _utils.t.spaceT("marginRight"),
  marginInlineEnd: _utils.t.spaceT("marginInlineEnd"),
  marginBottom: _utils.t.spaceT("marginBottom"),
  marginBlockEnd: _utils.t.spaceT("marginBlockEnd"),
  marginLeft: _utils.t.spaceT("marginLeft"),
  marginInlineStart: _utils.t.spaceT("marginInlineStart"),
  marginX: _utils.t.spaceT(["marginLeft", "marginRight"]),
  marginInline: _utils.t.spaceT("marginInline"),
  marginY: _utils.t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: _utils.t.spaceT("marginBlock"),
  padding: _utils.t.space("padding"),
  paddingTop: _utils.t.space("paddingTop"),
  paddingBlockStart: _utils.t.space("paddingBlockStart"),
  paddingRight: _utils.t.space("paddingRight"),
  paddingBottom: _utils.t.space("paddingBottom"),
  paddingBlockEnd: _utils.t.space("paddingBlockEnd"),
  paddingLeft: _utils.t.space("paddingLeft"),
  paddingInlineStart: _utils.t.space("paddingInlineStart"),
  paddingInlineEnd: _utils.t.space("paddingInlineEnd"),
  paddingX: _utils.t.space(["paddingLeft", "paddingRight"]),
  paddingInline: _utils.t.space("paddingInline"),
  paddingY: _utils.t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: _utils.t.space("paddingBlock")
};
Object.assign(config, {
  m: config.margin,
  mt: config.marginTop,
  mr: config.marginRight,
  me: config.marginInlineEnd,
  marginEnd: config.marginInlineEnd,
  mb: config.marginBottom,
  ml: config.marginLeft,
  ms: config.marginInlineStart,
  marginStart: config.marginInlineStart,
  mx: config.marginX,
  my: config.marginY,
  p: config.padding,
  pt: config.paddingTop,
  py: config.paddingY,
  px: config.paddingX,
  pb: config.paddingBottom,
  pl: config.paddingLeft,
  ps: config.paddingInlineStart,
  paddingStart: config.paddingInlineStart,
  pr: config.paddingRight,
  pe: config.paddingInlineEnd,
  paddingEnd: config.paddingInlineEnd
});
/**
 * Types for space related CSS properties
 */

/**
 * Converts shorthand or longhand margin and padding props to margin and padding CSS declarations
 *
 * - Numbers from 0-4 (or the length of theme.space) are converted to values on the spacing scale.
 * - Negative values can be used for negative margins.
 * - Numbers greater than the length of the theme.space array are converted to raw pixel values.
 * - String values are passed as raw CSS values.
 * - Array values are converted into responsive values.
 */
var space = (0, _core.system)(config);
exports.space = space;
var spaceParser = (0, _core.createParser)(config);
exports.spaceParser = spaceParser;
//# sourceMappingURL=space.js.map